import { Trans } from '@lingui/macro'

import * as React from 'react'

import { ButtonLarge } from '~ui/components/buttons/ButtonSizes/ButtonLarge'

import { useOrderSubmitHandlers } from '../../FormScreen/hooks/useOrderSubmitHandlers'
import { useGatewayUrlsCtx, usePaymentLockedOrderCtx } from '../contexts/PaymentLockedOrderProvider'

type TProps = NoChildren

/**
 * Button that will navigate the customer back to the payment gateway to finish OR to cancel the payment in process.
 */
export const ReturnToPaymentButton: React.FC<TProps> = () => {
  const { navigateToGateway } = useOrderSubmitHandlers()
  const gatewayUrls = useGatewayUrlsCtx()

  const order = usePaymentLockedOrderCtx()
  const isLoading = !order || !gatewayUrls

  const goToPaymentGateway = () => {
    if (isLoading) {
      return
    }

    // get the first non-null url
    // handle possible errors
    // navigate to the gateway
    navigateToGateway({ orderId: order.id, gatewayUrls })
  }

  return (
    <ButtonLarge
      bgColor={`conversion`}
      onClick={goToPaymentGateway}
      state={isLoading ? `loading` : `enabled`}
    >
      <Trans>Go to payment</Trans>
    </ButtonLarge>
  )
}
